<template>
  <footer class="footer">
    <div class="container">
      <p>© {{ year }} 加恒科技. 保留所有权利。</p>
      <div class="small">
        由 Vue 构建 · 加恒科技官网 · <a href="#legal">隐私与条款</a> ·
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" aria-label="访问工信部备案查询网站" title="粤ICP备2025484591号-1 — 在新窗口打开">粤ICP备2025484591号-1</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return { year: new Date().getFullYear() }
  }
}
</script>

<style scoped>
.footer {
  padding: 28px 16px;
  background: #0b1020;
  color: #94a3b8;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.container {
  max-width: 1100px;
  margin: 0 auto;
}
.small {
  font-size: 12px;
  opacity: 0.9;
}

.small a {
  color: inherit;
  text-decoration: underline;
}
</style>


